/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react';
import styled from 'styled-components';
import { isMobile } from 'react-device-detect';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import ScreenBottomMessageBar from '../../../common/ScreenBottomMessageBar';
import Loading from '../../../../commonComponents/Loading';
import { isLoggedIn } from '../../../../core/localStorage';
import AutoLogout from '../../../common/AutoLogout';
import kellyPartnersLogoBlueSvg from '../../../../images/kellyPartnersLogoBlue.svg';
import {
	appHeaderHeight,
	blackColour,
	borderGrey,
	brandingColourHeavy,
	globalHeaderZIndex,
	pageContentMaxWidth,
	tabletPortraitMinWidth,
	whiteColour
} from '../../../cssConstants';
import PublicContent from './PublicContent';
import { StyledGrid } from '../../../Styles';
import { scrollToPageTop } from '../../../../lib/utils';
import useLoadingStore from '../../../../zustandStore/loadingStateStore';

const Layout = ({ children }: Props) => {
	const { pathname } = useLocation();
	const loading = useLoadingStore((state) => state.loading);

	useEffect(() => {
		scrollToPageTop();
	}, [pathname]);

	return (
		<PageContainer>
			<HeaderWrapper>
				<HeaderLogo src={kellyPartnersLogoBlueSvg} alt="Kelly+Partners Logo" />
			</HeaderWrapper>
			<PublicContent>{children}</PublicContent>
			<ScreenBottomMessageBar />
			{loading && <Loading />}
		</PageContainer>
	);
};

const InnerLayout = (props: Props) => (
	<Layout {...defaultProps} {...props}>
		{props.children}
	</Layout>
);

// Only auto logout for web app as user's phone will lock out screen after a few minutes,
// so the mobile app will stay open and be inactive, so would auto logout mobile app users always (refresh token expires in 2 hours).
const PublicAutoLogoutLayout = (props: Props) => {
	return isLoggedIn() && !isMobile ? (
		<AutoLogout>
			<InnerLayout {...defaultProps} {...props} />
		</AutoLogout>
	) : (
		<InnerLayout {...defaultProps} {...props} />
	);
};

interface Props {
	children: React.ReactNode;
}

const defaultProps = {
	singleColumn: false,
	newDesign: false,
	whiteBackground: true,
	showFooter: true
};

export default PublicAutoLogoutLayout;

const PageContainer = styled.div`
	background-color: ${whiteColour};
	padding: 10px;
	min-height: 100%;

	@media (min-width: ${tabletPortraitMinWidth}) {
		padding: 40px;
	}
`;

export const PublicLogoWrapper = styled.section`
	top: 0;
	width: 100%;
	background: white;
	z-index: ${globalHeaderZIndex};
	text-align: center;
	padding: 15px;

	@media (min-width: ${tabletPortraitMinWidth}) {
		padding: 30px;
	}
`;

export const PublicHeaderLogo = styled.img`
	height: 80px;
	width: 200px;

	@media (min-width: ${tabletPortraitMinWidth}) {
		height: 140px;
		width: 350px;
	}
`;

const HeaderWrapper = styled.section`
	top: 0;
	width: 100%;
	padding: 62px calc((100% - ${pageContentMaxWidth}) / 2) 50px calc((100% - ${pageContentMaxWidth}) / 2);
	background: ${whiteColour};
	z-index: ${globalHeaderZIndex};
	text-align: center;
	padding: 10px;

	@media (min-width: ${tabletPortraitMinWidth}) {
		height: ${appHeaderHeight};
		padding: 20px;
	}

	@media print {
		position: relative !important;
	}
`;

const HeaderLogo = styled.img`
	height: 60px;
	width: 250px;

	@media (min-width: ${tabletPortraitMinWidth}) {
		height: 80px;
		width: 350px;
	}
`;

interface TitleParagraphProps {
	color?: string;
	$bold?: boolean;
}

export const TitleParagraph = styled.p<TitleParagraphProps>`
	text-align: center;
	font-size: 20px;
	margin: 20px 0;
	font-weight: ${({ $bold }) => ($bold ? 500 : 'normal')};
	color: ${({ color }) => color || brandingColourHeavy};

	@media (min-width: ${tabletPortraitMinWidth}) {
		font-size: 35px;
	}
`;

export const SubTitleParagraph = styled.p`
	text-align: center;
	font-size: 16px;
	color: ${blackColour};
	margin-bottom: 30px;

	@media (min-width: ${tabletPortraitMinWidth}) {
		font-size: 20px;
	}
`;

export const StyledForm = styled.form`
	display: grid;

	@media (min-width: ${tabletPortraitMinWidth}) {
		gap: 15px;
	}
`;

export const StyledFormDiv = styled.div`
	width: 100%;
	margin-right: 0;
	display: flex;
	flex-wrap: wrap;

	@media (min-width: ${tabletPortraitMinWidth}) {
		justify-content: center;
		flex-wrap: nowrap;
	}

	> div {
		@media (min-width: ${tabletPortraitMinWidth}) {
			width: calc(33.33% - 10px);

			&:nth-child(1),
			&:nth-child(2) {
				margin-right: 20px; /* Or any value you want */
			}

			&:nth-child(3n) {
				margin-right: 0;
			}
		}
	}
`;

export const StyledGridContainer = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;

	.k-grid-toolbar {
		background: none;
		padding-left: 0;
		border-width: 1px 0;
		border-color: ${borderGrey};
		border-opacity: 0.5;
	}

	div.k-grid-norecords {
		width: auto !important;
	}

	.k-grid-norecords-template {
		border: 0px;
	}
`;

export const PublicStyledGrid = styled(StyledGrid)`
	thead.k-table-thead {
		background: none;
		font-weight: 500;
		font-size: 14px;

		@media (min-width: ${tabletPortraitMinWidth}) {
			font-size: 16px;
		}
	}
`;

export const StyledLabel = styled.div`
	padding: 10px 0 10px 0;
	font-size: 16px;
	color: ${blackColour};

	@media (min-width: ${tabletPortraitMinWidth}) {
	}
`;
